import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthSessionService } from '@auth/services/auth-session.service';

/**
 * Legacy-parity HTTP interceptor: immediately signs the user out on any 401 response.
 */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const authSession = inject(AuthSessionService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authSession.logoutUnauthorized();
      }
      return throwError(() => error);
    })
  );
};
